import React, { useState, useEffect } from "react";

function Paginador({ page = 1, setPage = () => {}, totalPages = 1 }) {
  // Aseguramos que totalPages sea al menos 1
  const safeTotalPages = totalPages >= 1 ? totalPages : 1;
  // Aseguramos que page esté en el rango [1, safeTotalPages]
  const safePage = page >= 1 && page <= safeTotalPages ? page : 1;

  // Estado local para el valor del input, siempre en formato string
  const [pageInput, setPageInput] = useState(safePage.toString());

  // Cada vez que el valor de la página segura cambia, actualizamos el input
  useEffect(() => {
    setPageInput(safePage.toString());
  }, [safePage]);

  // Permite solo dígitos en el input
  const handleChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, "");
    setPageInput(numericValue);
  };

  // Al perder el foco, se valida el valor ingresado y se actualiza la página
  const handleBlur = () => {
    if (!pageInput) {
      // Si está vacío, se restaura el valor actual
      setPageInput(safePage.toString());
      return;
    }
    const numericValue = parseInt(pageInput, 10);
    if (numericValue < 1) {
      setPage(1);
    } else if (numericValue > safeTotalPages) {
      setPage(safeTotalPages);
    } else {
      setPage(numericValue);
    }
  };

  // Permite confirmar con Enter (simula el blur)
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  // Funciones para cambiar la página con las flechas
  const handlePrevPage = () => {
    if (safePage > 1) {
      setPage(safePage - 1);
    }
  };

  const handleNextPage = () => {
    if (safePage < safeTotalPages) {
      setPage(safePage + 1);
    }
  };

  return (
    <div className="menu-numeros">
      <div className="numero-3">
        <input
          className="numero-texto-3"
          type="text"
          value={pageInput}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        />
      </div>
      <p className="menu-numero-texto">de {safeTotalPages} páginas</p>
      <div className="menu-flechas">
        <img
          className="angulo-pequeno-izquierdo-2"
          src="images/angulo-pequeno-izquierdo-2.svg"
          alt="Flecha izquierda"
          onClick={handlePrevPage}
          style={{ cursor: safePage > 1 ? "pointer" : "not-allowed" }}
        />
        <img
          className="angulo-pequeno-derecho-2"
          src="images/angulo-pequeno-derecho-2.svg"
          alt="Flecha derecha"
          onClick={handleNextPage}
          style={{
            cursor: safePage < safeTotalPages ? "pointer" : "not-allowed",
          }}
        />
      </div>
    </div>
  );
}

export default Paginador;
